import { OracleQuantifyProvider } from '@modules/oracle/components/OracleQuantifyProvider';
import { OracleQuantifyResponseStepDetailsDialog } from '@modules/oracle/components/OracleSearchResponseStepDetailsDialog/OracleQuantifyResponseStepDetailsDialog';
import { OracleSummaryStepDetailsDialog } from '@modules/oracle/components/OracleSearchResponseStepDetailsDialog/OracleSummaryStepDetailsDialog';
import { getAssistantResponseEqlType } from '@modules/oracle/utils';
import { QueryBuilderStoreProvider } from '@modules/queryBuilder/store/QueryBuilderStoreProvider';
import { AssistantResponseTokenV2 } from 'generated/graphql';

interface OracleSearchResponseStepDetailsDialogProps {
  isOpen: boolean;
  onClose: () => void;
  isReadOnly?: boolean;
  assistantResponseTokenV2List: AssistantResponseTokenV2[];
  promptID: string;
  isLoading?: boolean;
  stepID: string;
  stepTitle: string;
}

export function OracleSearchResponseStepDetailsDialog({
  onClose,
  isOpen,
  stepID,
  promptID,
  isReadOnly,
  isLoading,
  assistantResponseTokenV2List,
  stepTitle,
}: OracleSearchResponseStepDetailsDialogProps) {
  const assistantResponseEqlToken = assistantResponseTokenV2List.find(
    (token) => token.eql?.eql,
  )?.eql;

  const eqlResponseType = getAssistantResponseEqlType(
    assistantResponseTokenV2List,
  );

  if (eqlResponseType === 'quantify' && assistantResponseEqlToken) {
    return (
      <OracleQuantifyProvider>
        <OracleQuantifyResponseStepDetailsDialog
          assistantResponseEqlToken={assistantResponseEqlToken}
          isOpen={isOpen}
          onClose={onClose}
          isReadOnly={isReadOnly}
          promptID={promptID}
          stepID={stepID}
          stepTitle={stepTitle}
        />
      </OracleQuantifyProvider>
    );
  }

  if (eqlResponseType === 'summary' && assistantResponseEqlToken?.eql) {
    return (
      <QueryBuilderStoreProvider>
        <OracleSummaryStepDetailsDialog
          stepID={stepID}
          isOpen={isOpen}
          onClose={onClose}
          assistantResponseTokenV2List={assistantResponseTokenV2List}
          eqlQuery={assistantResponseEqlToken.eql}
          isReadOnly={isReadOnly}
          promptID={promptID}
          isLoading={isLoading}
          stepTitle={stepTitle}
        />
      </QueryBuilderStoreProvider>
    );
  }

  return null;
}
